const global = require('../../config/configViaturas');

function formateDate(str) {
  try {
    if (str) {
      const [dateComponents, timeComponents] = str.split(' ');
      // console.log(dateComponents); // 👉️ "22/04/2022"
      // console.log(timeComponents); // 👉️ "07:30:16"

      const [day, month, year] = dateComponents.split('/');
      const [hours, minutes, seconds] = timeComponents.split(':');

      const date = new Date(+year, month - 1, +day, +hours, +minutes, +seconds);
      return date;
    }
    return '';
    // console.log(date);
  } catch (error) {
    console.log('error', error);
  }
}

/**
 * Esta é uma função verifica se é numerico
 * @example
 *  isNumeric(2) // true
 * @param   {number} value   valor
 * @returns {boolean} Boleano
 */

function isNumeric(value) {
  return /^-?\d+$/.test(value);
}

function formatNumber(value) {
  //O objeto Intl.NumberFormat é um construtor para objetos que habilita formatação de número sensível a linguagem.
  //?Ver Mais  https://developer.mozilla.org/pt-BR/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat

  try {
    //Formatar numeros que vem dos Km,...
    const formatter = Intl.NumberFormat('pt-pt');
    return formatter.format(value);
  } catch (error) {
    console.log('error', error);
  }
}
function formatNumberCurrency(value, casas) {
  //O objeto Intl.NumberFormat é um construtor para objetos que habilita formatação de número sensível a linguagem.
  //?Ver Mais  https://developer.mozilla.org/pt-BR/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat
  try {
    //Formatar numeros que vem do Preço , Preço Promoção , Valor de Mensalidade,...
    const formatter = Intl.NumberFormat('fr-Fr', {
      style: 'currency',
      currency: 'EUR',
    });
    value = formatter.format(value);

    return casas === '2' ? value : value.replace(',00', '');
  } catch (error) {
    console.log('error', error);
  }
}
function isZero(param) {
  // Verifica se o valor vem igual a zero

  try {
    if (param !== '') {
      if (param === 0) {
        param = '';
      }
      if (param === '0') {
        param = '';
      }
    }

    return param;
  } catch (error) {
    console.log('error', error);
  }
}
function tratarCombustivel(Combustivel) {
  // Verifica se a string tem a palavra string para "Híbrido" para encortar a palavra
  try {
    if (Combustivel && isNaN(Combustivel) && Combustivel.includes('Híbrido')) {
      Combustivel = 'Híbrido';
    }

    return Combustivel;
  } catch (error) {
    console.log('error', error);
    return '';
  }
}
function tratarLink(marca, modelo, codigo, Viatura) {
  //cria o link para as viaturas.
  //Limpa a Marca e Modelo , e colocar o codigo e o tipo de viatura(carros , motas e barcos)
  try {
    const aux_marca_clean = LimparToUrl(marca) || 'noname';
    const aux_modelo_clean = LimparToUrl(modelo) || 'noname';
    const aux_viatura_clean = LimparToUrl(Viatura) || 'noname';
    const aux_codigo_clean = codigo;

    if (!aux_marca_clean && !aux_modelo_clean && !aux_viatura_clean && !aux_codigo_clean) {
      return '/';
    }

    const location = `/${aux_viatura_clean}/${aux_marca_clean}/${aux_modelo_clean}/${aux_codigo_clean}/`;
    return location;
  } catch (error) {
    console.log('error', error);
  }
}
function tratarLinkFinanciamento(marca, modelo, codigo, Viatura, Url) {
  //cria o link para as viaturas.
  //Limpa a Marca e Modelo , e colocar o codigo e o tipo de viatura(carros , motas e barcos)
  try {
    const aux_marca_clean = LimparToUrl(marca);
    const aux_modelo_clean = LimparToUrl(modelo);
    const aux_codigo_clean = codigo;

    if (!Url || !Url.charAt(0) === '/' || !Url.charAt(Url.length - 1) === '/') {
      return '/';
    }

    if (!aux_marca_clean && !aux_modelo_clean && !aux_codigo_clean) {
      return '/';
    }

    if (
      !Url ||
      !Url.charAt(0) === '/' ||
      !Url.charAt(Url.length - 1) === '/' ||
      (!aux_marca_clean && !aux_modelo_clean && !aux_codigo_clean)
    ) {
      return '/';
    }

    const location = `${Url}${aux_codigo_clean}/${
      Viatura !== 'barcos' ? `${aux_marca_clean}-${aux_modelo_clean}` : `${aux_marca_clean}`
    }`;
    return location;
  } catch (error) {
    console.log('error', error);
  }
}

function LimparToUrl(text) {
  try {
    let textLimpo = '';
    // Lista de caracteres especiais que serão substituídos:
    const from = 'ãàáäâẽèéëêìíïîõòóöôùúüûñç·/_,:;';

    // Lista de caracteres que serão adicionados em relação aos anteriores:
    const to = 'aaaaaeeeeeiiiiooooouuuunc------';
    if (text !== '') {
      // Converte o texto para caixa baixa:
      textLimpo = text.toLocaleLowerCase();
      // Remove qualquer caractere em branco do final do texto:
      textLimpo = textLimpo.replace(/^\s+|\s+$/g, '');

      // Substitui todos os caracteres especiais:
      for (let i = 0, l = from.length; i < l; i++) {
        textLimpo = textLimpo.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
      }
    }
    // Remove qualquer caractere inválido que possa ter sobrado no texto:
    textLimpo = textLimpo.replace(/[^a-z0-9 -]/g, '');
    // Substitui os espaços em branco por hífen:
    textLimpo = textLimpo.replace(/\s+/g, '-');
    return textLimpo;
  } catch (error) {
    console.log('error', error);
  }
}

function tratarAnoMes(ano, mes) {
  try {
    //Traforma o mes e ano

    let mesTxt;
    switch (mes) {
      case '1':
      case 1:
        mesTxt = 'Jan.';
        break;
      case '2':
      case 2:
        mesTxt = 'Fev.';
        break;
      case '3':
      case 3:
        mesTxt = 'Mar.';
        break;
      case '4':
      case 4:
        mesTxt = 'Abr.';
        break;
      case '5':
      case 5:
        mesTxt = 'Mai.';
        break;
      case '6':
      case 6:
        mesTxt = 'Jun.';
        break;
      case '7':
      case 7:
        mesTxt = 'Jul.';
        break;
      case '8':
      case 8:
        mesTxt = 'Ago.';
        break;
      case '9':
      case 9:
        mesTxt = 'Set.';
        break;
      case '10':
      case 10:
        mesTxt = 'Out.';
        break;
      case '11':
      case 11:
        mesTxt = 'Nov.';
        break;
      case '12':
      case 12:
        mesTxt = 'Dez.';
        break;
      default:
        mesTxt = '';
        break;
    }

    let anoFormat = isZero(ano);
    let AnoMes = '';

    if (parseInt(anoFormat)) {
      AnoMes = `${mesTxt !== '' ? `${mesTxt} ` : ''}${anoFormat}`;
    } else {
      AnoMes = '';
    }

    return AnoMes;
  } catch (error) {
    console.log('error', error);
  }
}
function tratarKm(km, naoExiste) {
  try {
    // trata a informação dos km
    let kmFormat = isZero(km);
    if (parseInt(kmFormat)) {
      kmFormat = formatNumber(km);
      if (naoExiste) {
        return `${kmFormat}`;
      } else {
        return `${kmFormat} km`;
      }
    } else {
      return '';
    }
  } catch (error) {
    console.log('error', error);
  }
}

function tratarPreco(preco) {
  try {
    // trata a informação do Preco
    let precoText = '';
    let precoFormat = isZero(preco);
    if (parseInt(precoFormat)) {
      precoText = formatNumberCurrency(precoFormat, 0);
    }
    return precoText;
  } catch (error) {
    console.log('error', error);
  }
}

function SplitValue(value) {
  try {
    // split do vaor
    let myArray;
    if (value !== '' && value !== 0 && value !== '0') {
      if (value.includes('\u202f')) {
        myArray = value.split('\u202f');
      } else {
        myArray = ['', value];
      }
    } else {
      myArray = ['', ''];
    }

    return myArray;
  } catch (error) {
    console.log('error', error);
    return ['', ''];
  }
}

function tratarPrecoPromo(precoPromo) {
  try {
    // trata a informação do Preco Promoçao
    precoPromo = isZero(precoPromo);
    let precoPromoText = '';
    if (parseInt(precoPromo)) {
      precoPromoText = formatNumberCurrency(precoPromo, 0);
    }
    return precoPromoText;
  } catch (error) {
    console.log('error', error);
  }
}
function tratarValorMensalidade(valorMensalidade) {
  try {
    // trata a informação do valor Mensalidade
    valorMensalidade = isZero(valorMensalidade);
    if (typeof valorMensalidade === 'string' || valorMensalidade instanceof String) {
      valorMensalidade = valorMensalidade.replace(',', '.').replace('€', '');
    }

    let valorMensalidadeText = '';
    if (parseFloat(valorMensalidade)) {
      valorMensalidadeText = formatNumberCurrency(valorMensalidade, '2');
    }

    return valorMensalidadeText;
  } catch (error) {
    console.log('error', error);
  }
}

function tratarMotorizacao(versaoAlternativa, motorizacao) {
  try {
    // trata a informação do Motorizacao
    if (versaoAlternativa) {
      return versaoAlternativa;
    }
    return motorizacao ? motorizacao : '';
  } catch (error) {
    console.log('error', error);
  }
}

function tratarValorFinanciado(Preco, PrecoPromo, ValorEntrada) {
  try {
    // trata a informação do Valor Financiado
    let precoInit;
    let PrecoPromoFormat = isZero(PrecoPromo);
    let PrecoFormat = isZero(Preco);
    parseInt(PrecoPromoFormat)
      ? (precoInit = PrecoPromo)
      : parseInt(PrecoFormat)
        ? (precoInit = Preco)
        : (precoInit = 999999);

    return isNumeric(ValorEntrada) ? formatNumberCurrency(precoInit - ValorEntrada, 0) : '';
  } catch (error) {
    console.log('error', error);
  }
}

function tratarCilindrada(cilindrada) {
  try {
    // trata a informação do valor Cilindrada
    let valorCilindrada = '';
    if (cilindrada !== '') {
      valorCilindrada = formatNumber(cilindrada, 0);
      valorCilindrada = valorCilindrada + ' Cc';
    }
    return valorCilindrada;
  } catch (error) {
    console.log('error', error);
  }
}
function tratarPotencia(potencia, tipoViatura) {
  try {
    // trata a informação do valor Potencia
    let valorPotencia = '';
    if (potencia !== '') {
      valorPotencia = formatNumber(isNaN(potencia) ? potencia.replace(',', '.') : potencia, 0);
      valorPotencia = valorPotencia + `${tipoViatura === 'barcos' ? ' Hp' : ' Cv'}`;
    }
    return valorPotencia;
  } catch (error) {
    console.log('error', error);
  }
}
function tratarConsumos(ConsumoUrbano, ConsumoExtra, ConsumoMisto) {
  try {
    // trata a informação do valor dos Consumos

    let valorConsumos = '';
    if (ConsumoMisto) {
      valorConsumos = valorConsumos + ConsumoMisto + 'L/100Km (Combinado) <br>';
    }
    if (ConsumoUrbano) {
      valorConsumos = valorConsumos + ConsumoUrbano + 'L/100Km (Urbano)  <br>';
    }
    if (ConsumoExtra) {
      valorConsumos = valorConsumos + ConsumoExtra + 'L/100Km (Extra Urbano) <br>';
    }
    return valorConsumos;
  } catch (error) {
    console.log('error', error);
  }
}
function tratarNacional(nacional) {
  try {
    // trata a informação do valor dos Nacionalidade

    let textNacional = '';
    if (nacional === 1) {
      textNacional = 'Nacional';
    } else if (nacional === 2) {
      textNacional = 'Importado';
    } else {
      textNacional = '';
    }
    return textNacional;
  } catch (error) {
    console.log('error', error);
  }
}
function tratar2Chave(SegundaChave) {
  try {
    // trata a informação da Segunda Chave
    let textSegundaChave = '';
    if (SegundaChave === true) {
      textSegundaChave = 'Sim';
    }
    return textSegundaChave;
  } catch (error) {
    console.log('error', error);
  }
}
function tratarClassePortagem(ClassePortagem) {
  try {
    // trata a informação da Clase de Portagem
    let textClassePortagem = '';
    if (ClassePortagem !== '' && ClassePortagem !== '-1') {
      textClassePortagem = 'Classe ' + ClassePortagem;
    }
    return textClassePortagem;
  } catch (error) {
    console.log('error', error);
  }
}
function tratarLivroRevisoes(ExtrasSoltos) {
  try {
    // trata a informação da Livro de revisões completo

    let textLivroRevisoes = '';
    if (ExtrasSoltos && ExtrasSoltos.includes('Livro de revisões completo')) {
      textLivroRevisoes = 'Sim';
    }

    return textLivroRevisoes;
  } catch (error) {
    console.log('error', error);
    return '';
  }
}

function tratarNumeroRegistos(numero) {
  try {
    // trata a informação da numero de registos

    if (numero === undefined || numero === null) {
      return '';
    }

    return numero;
  } catch (error) {
    console.log('error', error);
    return '';
  }
}

function tratarUrl(url, url2) {
  try {
    // trata a o url do video do youtube

    let linkUrl = '';
    if (url && url !== '') {
      linkUrl = url;
    }
    if (url2 && url2 !== '') {
      linkUrl = url2;
    }

    return linkUrl;
  } catch (error) {
    console.log('error', error);
  }
}
function tratarRegistoManutencao(Ano, Mes) {
  try {
    // trata a informação da Livro de revisões completo

    // Verifica quanto dias tem a viatura
    let tempo = '';
    tempo = new Date().getFullYear() - Ano;
    tempo > 3 ? (tempo = tratarAnoMes(Ano, Mes)) : (tempo = tempo + ' Anos');
    //se tiver mais que 3 anos coloca o mes e o ano

    return tempo;
  } catch (error) {
    console.log('error', error);
  }
}
function tratarDataManutencao(Data) {
  try {
    //Trata de data de Intervenção

    let textData;
    let mesTxt;
    let dataExtenso = Data.split(' ');
    dataExtenso = dataExtenso[0].split('/');

    switch (dataExtenso[1]) {
      case '01':
        mesTxt = 'Janeiro';
        break;
      case '02':
        mesTxt = 'Fevereiro';
        break;
      case '03':
        mesTxt = 'Março';
        break;
      case '04':
        mesTxt = 'Abril';
        break;
      case '05':
        mesTxt = 'Maio';
        break;
      case '06':
        mesTxt = 'Junho';
        break;
      case '07':
        mesTxt = 'Julho';
        break;
      case '08':
        mesTxt = 'Agosto';
        break;
      case '09':
        mesTxt = 'Setembro';
        break;
      case '10':
        mesTxt = 'Outubro';
        break;
      case '11':
        mesTxt = 'Novembro';
        break;
      case '12':
        mesTxt = 'Dezembro';
        break;
      default:
        mesTxt = '';
        break;
    }

    textData = dataExtenso[0] + ' ' + mesTxt + ' de ' + dataExtenso[2];
    return textData;
  } catch (error) {
    console.log('error', error);
  }
}
function trataManutencaoMostraAno(Data, array, index) {
  try {
    //inica as variaveis
    let mostrarAno = 0;
    let dataExtensoAnterior;
    let anoAgora;

    // cria um array da data
    let dataExtenso = Data.split(' ');
    dataExtenso = dataExtenso[0].split('/');

    if (index === 0) {
      anoAgora = new Date().getFullYear();
    } else {
      const indexAnterior = index - 1;
      dataExtensoAnterior = array[indexAnterior].DataIntervencao.split(' ');
      dataExtensoAnterior = dataExtensoAnterior[0].split('/');
      anoAgora = parseInt(dataExtensoAnterior[2]);
    }

    const anoIntervençao = parseInt(dataExtenso[2]);

    anoIntervençao !== anoAgora && (mostrarAno = 1);

    return [mostrarAno, dataExtenso[2]];
  } catch (error) {
    console.log('error', error);
  }
}

function getMarcasComModelo(array, modelo) {
  const modeloIds = modelo.map(m => m.Id);
  return array
    .filter(carro => modeloIds.includes(carro.Modelo.Id))
    .map(carro => carro.Marca)
    .reduce((accum, marca) => {
      if (!accum.some(item => item.Id === marca.Id && item.Nome === marca.Nome)) {
        accum.push(marca);
      }
      return accum;
    }, []);
}

function getMarcasSemModelo(array, marcas, modelo) {
  const marcasComModelo = getMarcasComModelo(array, modelo);

  // Marcas selecionadas que não têm modelos selecionados
  const marcasSemModelo = marcas.filter(
    marca => !marcasComModelo.some(m => m.Id === marca.Id && m.Nome === marca.Nome),
  );

  return marcasSemModelo;
}

function filtraCarro(
  carro,
  {
    marcas,
    modelo,
    combustivel,
    segmento,
    transmissao,
    extras,
    anoInicial,
    anoFinal,
    precoInicial,
    precoFinal,
    kmInicial,
    kmFinal,
    potenciaInicial,
    lotacao,
    mensalidadeInicial,
    mensalidadeFinal,
    comprimentoInicial,
    comprimentoFinal,
    horasInicial,
    horasFinal,
    motores,
    referencia,
    categoria,
    subcategoria,
    titulo,
    marcaPecas,
    tempos,
    colunas,
    estado,
    combustivelPecas,
    pesoBrutoInicial,
    pesoBrutoFinal,
    capCargaInicial,
    capCargaFinal,
    tipo,
    ponto,
  },
  marcasSemModelo = [],
  pesquisa = false
) {
  const temParametros =
   pesquisa || 
    (marcas && marcas.length) ||
    (modelo && modelo.length) ||
    (combustivel && combustivel.length) ||
    (segmento && segmento.length) ||
    (transmissao && transmissao.length) ||
    (extras && extras.length) ||
    anoInicial ||
    anoFinal ||
    precoInicial ||
    precoFinal ||
    kmInicial ||
    kmFinal ||
    potenciaInicial ||
    (lotacao && lotacao.length) ||
    mensalidadeInicial ||
    mensalidadeFinal ||
    comprimentoInicial ||
    comprimentoFinal ||
    horasInicial ||
    horasFinal ||
    (motores && motores.length) ||
    referencia ||
    (categoria && categoria.length) ||
    (subcategoria && subcategoria.length) ||
    titulo ||
    marcaPecas ||
    (tempos && tempos.length) ||
    (colunas && colunas.length) ||
    (estado && estado.length) ||
    (combustivelPecas && combustivelPecas.length) ||
    pesoBrutoInicial ||
    pesoBrutoFinal ||
    capCargaInicial ||
    capCargaFinal ||
    tipo ||
    ponto;

  
  let result = temParametros ? carro.Vendido === false : true;

  if (marcas?.length && modelo?.length) {
    result &&=
      marcasSemModelo.some(m => m.Id === carro.Marca.Id && m.Nome === carro.Marca.Nome) ||
      modelo.some(m => m.Id === carro.Modelo.Id && m.Nome === carro.Modelo.Nome);
  } else if (modelo?.length) {
    result &&= modelo.some(m => m.Id === carro.Modelo.Id && m.Nome === carro.Modelo.Nome);
  } else if (marcas?.length) {
    result &&= marcas.some(m => m.Id === carro.Marca.Id && m.Nome === carro.Marca.Nome);
  }

  if (combustivel?.length) result &&= combustivel.includes(carro.Combustivel.Id);
  if (extras?.length)
    result &&= extras.every(extra =>
      carro.ExtrasSoltos?.toLowerCase().includes(extra.toLowerCase()),
    );
  if (ponto) result &&= carro.CodPontoVenda === parseInt(ponto);
  if (transmissao?.length) {
    if (transmissao.includes(1)) result &&= global.CaixaManual.includes(carro.Transmissao.Id);
    if (transmissao.includes(2)) result &&= global.CaixaAutomatica.includes(carro.Transmissao.Id);
  }
  if (segmento?.length) result &&= segmento.includes(carro.Tipo.Id);
  if (anoInicial > 0) result &&= parseInt(carro.Ano) >= anoInicial;
  if (anoFinal > 0) result &&= parseInt(carro.Ano) <= anoFinal;
  if (horasInicial > 0) result &&= parseInt(carro.Horas) >= horasInicial;
  if (horasFinal > 0) result &&= parseInt(carro.Horas) <= horasFinal;
  if (precoInicial > 0) result &&= parseInt(carro.Preco) >= precoInicial;
  if (precoFinal > 0) result &&= parseInt(carro.Preco) <= precoFinal;
  if (mensalidadeInicial)
    result &&=
      parseFloat(carro.ValorMensalidade?.toString().replace(',', '.')) >=
      parseFloat(mensalidadeInicial?.toString().replace(',', '.'));
  if (mensalidadeFinal)
    result &&=
      parseFloat(carro.ValorMensalidade?.toString().replace(',', '.')) <=
      parseFloat(mensalidadeFinal?.toString().replace(',', '.'));
  if (kmInicial > 0) result &&= parseInt(carro.Km) >= kmInicial;
  if (kmFinal > 0) result &&= parseInt(carro.Km) <= kmFinal;
  if (potenciaInicial > 0) result &&= carro.Potencia >= potenciaInicial;
  if (comprimentoInicial)
    result &&=
      parseFloat(carro.Comprimento?.toString().replace(',', '.')) >=
      parseFloat(comprimentoInicial?.toString().replace(',', '.'));
  if (comprimentoFinal)
    result &&=
      parseFloat(carro.Comprimento?.toString().replace(',', '.')) <=
      parseFloat(comprimentoFinal?.toString().replace(',', '.'));
  if (motores?.length) result &&= motores.includes(carro.NumeroMotores);
  if (lotacao?.length) result &&= lotacao.includes(carro.Lugares.Id);
  if (categoria?.length) result &&= categoria.includes(carro.Categoria.Id);
  if (subcategoria?.length) result &&= subcategoria.includes(carro.SubCategoria.Id);
  if (referencia) result &&= carro.Referencia?.toLowerCase().includes(referencia.toLowerCase());
  if (titulo) {
    if (Array.isArray(titulo) && titulo.length) {
      // Se for array, verifica se ALGUM item do array existe no Título do carro
      result &&= titulo.some(t => carro.Titulo?.toLowerCase().includes(t.toLowerCase().trim()));
    } else if (typeof titulo === 'string' && titulo.trim() !== '') {
      // Se for string, mantém a lógica original
      result &&= carro.Titulo?.toLowerCase().includes(titulo.toLowerCase().trim());
    }
  }
  if (titulo) {
    const titulosArr = (Array.isArray(titulo) ? titulo : [titulo])
      .map(t => t.trim())
      .filter(Boolean); // remove strings vazias

    if (titulosArr.length) {
      result &&= titulosArr.some(t => carro.Titulo?.toLowerCase().includes(t.toLowerCase()));
    }
  }
  if (marcaPecas) {
    const marcaPecasArr = (Array.isArray(marcaPecas) ? marcaPecas : [marcaPecas])
      .map(t => t.trim())
      .filter(Boolean); // remove strings vazias

    if (marcaPecasArr.length) {
      result &&= marcaPecasArr.some(t => carro.Marca.Nome?.toLowerCase().includes(t.toLowerCase()));
    }
  }

  if (tempos?.length) result &&= tempos.includes(carro.Tipo.Nome);
  if (colunas?.length) result &&= colunas.includes(carro.Coluna);
  if (estado?.length) result &&= estado.includes(carro.Estado.Nome);
  if (combustivelPecas?.length) result &&= combustivelPecas.includes(carro.Combustivel.Nome);
  if (pesoBrutoInicial)
    result &&=
      parseFloat(carro.PesoBruto?.toString().replace(',', '.')) >=
      parseFloat(pesoBrutoInicial?.toString().replace(',', '.'));
  if (pesoBrutoFinal)
    result &&=
      parseFloat(carro.PesoBruto?.toString().replace(',', '.')) <=
      parseFloat(pesoBrutoFinal?.toString().replace(',', '.'));
  if (capCargaInicial)
    result &&=
      parseFloat(carro.CapacidadeCarga?.toString().replace(',', '.')) >=
      parseFloat(capCargaInicial?.toString().replace(',', '.'));
  if (capCargaFinal)
    result &&=
      parseFloat(carro.CapacidadeCarga?.toString().replace(',', '.')) <=
      parseFloat(capCargaFinal?.toString().replace(',', '.'));
  if (tipo) result &&= carro.Viatura === tipo;

  return result;
}

const atualizarPesquisa = (
  marcas,
  modelo,
  combustivel,
  segmento,
  transmissao,
  extras,
  anoInicial,
  anoFinal,
  precoInicial,
  precoFinal,
  kmInicial,
  kmFinal,
  potenciaInicial,
  lotacao,
  mensalidadeInicial,
  mensalidadeFinal,
  comprimentoInicial,
  comprimentoFinal,
  horasInicial,
  horasFinal,
  motores,
  referencia,
  categoria,
  subcategoria,
  titulo,
  marcaPecas,
  tempos,
  colunas,
  estado,
  combustivelPecas,
  pesoBrutoInicial,
  pesoBrutoFinal,
  capCargaInicial,
  capCargaFinal,
  ordenar,
  ponto,
  tipo,
  array,
  set,
  infoJson,
) => {
  try {
    const filtroParams = {
      marcas,
      modelo,
      combustivel,
      segmento,
      transmissao,
      extras,
      anoInicial,
      anoFinal,
      precoInicial,
      precoFinal,
      kmInicial,
      kmFinal,
      potenciaInicial,
      lotacao,
      mensalidadeInicial,
      mensalidadeFinal,
      comprimentoInicial,
      comprimentoFinal,
      horasInicial,
      horasFinal,
      motores,
      referencia,
      categoria,
      subcategoria,
      titulo,
      marcaPecas,
      tempos,
      colunas,
      estado,
      combustivelPecas,
      pesoBrutoInicial,
      pesoBrutoFinal,
      capCargaInicial,
      capCargaFinal,
      tipo,
      ponto,
    };

    const marcasSemModelo = getMarcasSemModelo(array, marcas, modelo);

    const pesquisa = array.filter(carro => filtraCarro(carro, filtroParams, marcasSemModelo));

    set(
      SelectOrdenar(
        infoJson.Layout.Carros.ordenar.recentes,
        ordenar,
        pesquisa,
        infoJson.Layout.Carros.ordenar.tipo,
        infoJson.Layout.Carros.ordenar.vendidosMisturados,
      ),
    );
  } catch (error) {
    console.error('error', error);
  }
};

const NumeroAtualizarPesquisa = (
  array,
  marcas,
  modelo,
  combustivel,
  segmento,
  transmissao,
  extras,
  anoInicial,
  anoFinal,
  precoInicial,
  precoFinal,
  kmInicial,
  kmFinal,
  potenciaInicial,
  lotacao,
  horasInicial,
  horasFinal,
  comprimentoInicial,
  comprimentoFinal,
  motores,
  referencia,
  categoria,
  subcategoria,
  titulo,
  marcaPecas,
  tempos,
  colunas,
  estado,
  combustivelPecas,
  pesoBrutoInicial,
  pesoBrutoFinal,
  capCargaInicial,
  capCargaFinal,
) => {
  try {
    const filtroParams = {
      marcas,
      modelo,
      combustivel,
      segmento,
      transmissao,
      extras,
      anoInicial,
      anoFinal,
      precoInicial,
      precoFinal,
      kmInicial,
      kmFinal,
      potenciaInicial,
      lotacao,
      horasInicial,
      horasFinal,
      comprimentoInicial,
      comprimentoFinal,
      motores,
      referencia,
      categoria,
      subcategoria,
      titulo,
      marcaPecas,
      tempos,
      colunas,
      estado,
      combustivelPecas,
      pesoBrutoInicial,
      pesoBrutoFinal,
      capCargaInicial,
      capCargaFinal,
    };
    const marcasSemModelo = getMarcasSemModelo(array, marcas, modelo);
    const pesquisa = array.filter(carro => filtraCarro(carro, filtroParams, marcasSemModelo, true));
    return pesquisa.length;
  } catch (error) {
    console.log('error', error);
  }
};

const ordenarVendidos = (a, b) => a.Vendido - b.Vendido;

const ordenarListagem = (array, tipo, ordenarVendido) => {
  switch (tipo) {
    case 1:
      //sortMarcaAZ
      return array
        .sort(function (a, b) {
          const result = a.Marca.Nome.localeCompare(b.Marca.Nome);

          return result !== 0
            ? result
            : a.Viatura === 'barcos'
              ? result
              : a.Modelo.Nome.localeCompare(b.Modelo.Nome);
        })
        .sort(ordenarVendido ? (a, b) => true : ordenarVendidos)
        .map(item => {
          return item;
        });

    case 2:
      //sortMarcaZA

      return array
        .sort(function (a, b) {
          const result = b.Marca.Nome.localeCompare(a.Marca.Nome);

          return result !== 0
            ? result
            : b.Viatura === 'barcos'
              ? result
              : b.Modelo.Nome.localeCompare(a.Modelo.Nome);
        })
        .sort(ordenarVendido ? (a, b) => true : ordenarVendidos)
        .map(item => {
          return item;
        });

    case 3:
      // sortAnoMaior
      return array
        .sort((a, b) => {
          if (b.Ano !== a.Ano) {
            return b.Ano - a.Ano;
          } else {
            return b.Mes - a.Mes;
          }
        })
        .sort(ordenarVendido ? (a, b) => true : ordenarVendidos)
        .map(item => {
          return item;
        });

    case 4:
      // sortAnoMenor
      return array
        .sort((a, b) => {
          if (a.Ano !== b.Ano) {
            return a.Ano - b.Ano;
          } else {
            return a.Mes - b.Mes;
          }
        })
        .sort(ordenarVendido ? (a, b) => true : ordenarVendidos)
        .map(item => {
          return item;
        });

    case 5:
      // sortPrecoMaior
      return array
        .sort((a, b) => a.Preco - b.Preco)
        .sort(ordenarVendido ? (a, b) => true : ordenarVendidos)
        .map(item => {
          return item;
        });
    case 6:
      // sortPrecoMenor
      return array
        .sort((a, b) => b.Preco - a.Preco)
        .sort(ordenarVendido ? (a, b) => true : ordenarVendidos)
        .map(item => {
          return item;
        });
    case 7:
      return array
        .sort(
          (a, b) =>
            (b.UltimaAlteracao ? formateDate(b.UltimaAlteracao).getTime() : 0) -
            (a.UltimaAlteracao ? formateDate(a.UltimaAlteracao).getTime() : 0),
        )
        .sort(ordenarVendido ? (a, b) => true : ordenarVendidos)
        .map(item => {
          return item;
        });
    case 8:
      return array
        .sort(
          (a, b) =>
            (b.DataCriacao ? formateDate(b.DataCriacao).getTime() : 0) -
            (a.DataCriacao ? formateDate(a.DataCriacao).getTime() : 0),
        )
        .sort(ordenarVendido ? (a, b) => true : ordenarVendidos)
        .map(item => {
          return item;
        });

    default:
      return array
        .sort(function (a, b) {
          const result = a.Marca.Nome.localeCompare(b.Marca.Nome);

          return result !== 0
            ? result
            : a.Viatura === 'barcos'
              ? result
              : a.Modelo.Nome.localeCompare(b.Modelo.Nome);
        })
        .sort(ordenarVendido ? (a, b) => true : ordenarVendidos)
        .map(item => {
          return item;
        });
  }
};

const SelectOrdenar = (recentes, tipoAlterado, array, tipoInitial, ordenarVendido) => {
  try {
    switch (tipoAlterado) {
      case 1:
        return ordenarListagem(array, tipoAlterado, ordenarVendido);

      case 2:
        return ordenarListagem(array, tipoAlterado, ordenarVendido);

      case 3:
        return ordenarListagem(array, tipoAlterado, ordenarVendido);

      case 4:
        return ordenarListagem(array, tipoAlterado, ordenarVendido);

      case 5:
        return ordenarListagem(array, tipoAlterado, ordenarVendido);

      case 6:
        return ordenarListagem(array, tipoAlterado, ordenarVendido);

      case 8:
        return ordenarListagem(array, tipoAlterado, ordenarVendido);

      default:
        return ordenarListagem(array, recentes ? 7 : tipoInitial, ordenarVendido);
    }
  } catch (error) {
    console.log('error', error);
  }
};

const sortMarcaAZ = (array, set) => {
  try {
    const marcaAZ = array
      .sort(function (a, b) {
        if (a.Marca.Nome < b.Marca.Nome) {
          return -1;
        }
        if (a.Marca.Nome > b.Marca.Nome) {
          return 1;
        }
        return 0;
      })
      .map(item => {
        return item;
      });

    set(marcaAZ);
  } catch (error) {
    console.log('error', error);
  }
};

const createUrl = array => {
  try {
    const item = array
      .map(item => item.Nome.trim())
      .toString()
      .replaceAll(',', '--');

    return LimparToUrl(item);
  } catch (error) {
    console.log('error', error);
  }
};

const createArrayRapida = Array => {
  try {
    const allListaPorVender = Array.filter(carro => {
      return carro.Vendido === false;
    });
    const ExtrasSoltos = allListaPorVender.map(extras => {
      return extras.ExtrasSoltos;
    });
    let arrExtras = [
      'AC',
      'Ar Condicionado',
      'Ajuda ao parqueamento',
      'Alarme',
      'Android Auto',
      'Apoio de Braço',
      'Apple CarPlay',
      'Audi Smartphone interface',
      'Bancos Desportivos',
      'Bancos Dianteiros Aquecidos',
      'Bancos Dianteiros c/ Memória',
      'Bancos Dianteiros c/ Regulação Eléctrica',
      'Bancos Dianteiros com Apoio Lombar',
      'Bancos em Alcântara',
      'Bancos Ortopédicos',
      'Bancos Traseiros Aquecidos',
      'Bancos Traseiros c/ Config. Individual',
      'Bixenón',
      'Barras de Tejadilho',
      'Bluetooth',
      'Camara de Frente',
      'Câmara de Marcha',
      'Camara Laterais',
      'Capota Eléctrica',
      'Cruise Control',
      'Dianteiros Led',
      'Ecrã Consola Central',
      'Ecrã Encosto de Cabeça',
      'Ecrã Táctil ou Touch Screen',
      'Entrada AUX',
      'Estacionamento Automático',
      'Estofos em Pele',
      'Faróis Diurnos',
      'Full Led',
      'Função Luzes Coming & Leaving Home',
      'Ecrã Consola Central',
      'Gancho de Reboque',
      'GPS',
      'Head Up Display',
      'ISOFIX',
      'Jantes 14',
      'Jantes 15',
      'Jantes 16',
      'Jantes 17',
      'Jantes 18',
      'Jantes 19',
      'Jantes 20',
      'Jantes 21',
      'Jantes de Liga Leve',
      'Livro de revisões completo',
      'Luzes Traseiras LED',
      'Mirror Link',
      'MMI',
      'Porta Bagageira Automática',
      'Portas Laterais Automáticas',
      'Sensores Estacionamento',
      'Start and Stop',
      'Suspensão Desportiva',
      'Tecnologia Led',
      'Tecto De Abrir Eléctrico',
      'Tecto Panorâmico',
      'Travão de Mão Eléctrico',
      'Vidros Escurecidos',
      'Volante Desportivo',
      'Volante Multifunções',
      'Xenón',
    ];

    const extras = ExtrasSoltos.toString()
      .split(',')
      .map(extras => extras.trim())
      .filter(item => item !== '' && arrExtras.includes(item))
      .sort((a, b) => {
        if (a < b) {
          return -1;
        }
        if (a > b) {
          return 1;
        }
        return 0;
      })
      .reduce((accum, extra) => {
        const accumulator = [...accum];
        if (!accumulator.some(item => item === extra)) {
          accumulator.push(extra);
        }
        return accumulator;
      }, [])
      .map(extras => {
        return { Codigo: `1:${extras.trim()}`, Nome: extras.trim() };
      });

    const marca = allListaPorVender
      .filter(item => !['pecas', 'atrelados', 'motores'].includes(item.Viatura))
      .map(({ Marca }) => {
        return {
          Marca,
        };
      })
      .sort(function (a, b) {
        if (a.Marca.Nome < b.Marca.Nome) {
          return -1;
        }
        if (a.Marca.Nome > b.Marca.Nome) {
          return 1;
        }
        return 0;
      })
      .reduce((accum, carro) => {
        const accumulator = [...accum];
        if (!accumulator.some(item => item.Marca.Id === carro.Marca.Id && item.Marca.Nome === carro.Marca.Nome)) {
          accumulator.push(carro);
        }
        return accumulator;
      }, [])
      .map(marca => {
        return { Codigo: `2:${marca.Marca.Id}`, Nome: marca.Marca.Nome };
      });

    const modelo = allListaPorVender
      .filter(item => !['pecas', 'atrelados', 'motores', 'barcos'].includes(item.Viatura))
      .sort(function (a, b) {
        if (a.Modelo.Nome < b.Modelo.Nome) {
          return -1;
        }
        if (a.Modelo.Nome > b.Modelo.Nome) {
          return 1;
        }
        return 0;
      })
      .map(({ Modelo, Marca }) => {
        return {
          Modelo,
          Marca,
        };
      })
      .reduce((accum, carro) => {
        const accumulator = [...accum];
        if (!accumulator.some(item => item.Modelo.Id === carro.Modelo.Id)) {
          accumulator.push(carro);
        }
        return accumulator;
      }, [])
      .map(modelo => {
        return {
          Codigo: `3:${modelo.Modelo.Id}`,
          Nome: `${modelo.Marca.Nome} ${modelo.Modelo.Nome}`,
          Modelo: modelo.Modelo.Nome,
        };
      });

    const combustivel = allListaPorVender
      .filter(
        item => !['pecas', 'atrelados', 'motores'].includes(item.Viatura) && item.Combustivel.Nome,
      )
      .map(({ Combustivel }) => {
        return {
          Combustivel,
        };
      })
      .sort(function (a, b) {
        if (a.Combustivel.Nome < b.Combustivel.Nome) {
          return -1;
        }
        if (a.Combustivel.Nome > b.Combustivel.Nome) {
          return 1;
        }
        return 0;
      })
      .reduce((accum, carro) => {
        const accumulator = [...accum];
        if (!accumulator.some(item => item.Combustivel.Id === carro.Combustivel.Id)) {
          accumulator.push(carro);
        }
        return accumulator;
      }, [])
      .map(combustivel => {
        return {
          Codigo: `4:${combustivel.Combustivel.Id}`,
          Nome: combustivel.Combustivel.Nome,
        };
      });

    const tipo = allListaPorVender
      .filter(item => !['pecas', 'atrelados', 'motores'].includes(item.Viatura) && item.Tipo.Nome)
      .map(({ Tipo }) => {
        return {
          Tipo,
        };
      })
      .sort(function (a, b) {
        if (a.Tipo.Nome < b.Tipo.Nome) {
          return -1;
        }
        if (a.Tipo.Nome > b.Tipo.Nome) {
          return 1;
        }
        return 0;
      })
      .reduce((accum, carro) => {
        const accumulator = [...accum];
        if (!accumulator.some(item => item.Tipo.Id === carro.Tipo.Id)) {
          accumulator.push(carro);
        }
        return accumulator;
      }, [])
      .map(tipo => {
        return {
          Codigo: `5:${tipo.Tipo.Id}`,
          Nome: tipo.Tipo.Nome,
        };
      });

    const lugares = allListaPorVender
      .filter(
        item => !['pecas', 'atrelados', 'motores'].includes(item.Viatura) && item.Lugares.Nome,
      )
      .map(({ Lugares }) => {
        return {
          Lugares,
        };
      })
      .sort(function (a, b) {
        if (a.Lugares.Nome < b.Lugares.Nome) {
          return -1;
        }
        if (a.Lugares.Nome > b.Lugares.Nome) {
          return 1;
        }
        return 0;
      })
      .reduce((accum, carro) => {
        const accumulator = [...accum];
        if (!accumulator.some(item => item.Lugares.Id === carro.Lugares.Id)) {
          accumulator.push(carro);
        }
        return accumulator;
      }, [])
      .map(lugares => {
        return {
          Codigo: `6:${lugares.Lugares.Id}`,
          Nome: lugares.Lugares.Nome,
        };
      });
    const transmissao = [
      { Codigo: `7:1`, Nome: 'Automática' },
      { Codigo: `7:2`, Nome: 'Manual' },
    ];

    const titulo = allListaPorVender
      .filter(item => ['pecas', 'atrelados', 'motores'].includes(item.Viatura))
      .map(({ Titulo }) => {
        return {
          Titulo: Titulo.trim(),
        };
      })
      .sort(function (a, b) {
        if (a.Titulo < b.Titulo) {
          return -1;
        }
        if (a.Titulo > b.Titulo) {
          return 1;
        }
        return 0;
      })
      .reduce((accum, carro) => {
        const accumulator = [...accum];
        if (!accumulator.some(item => item.Titulo === carro.Titulo)) {
          accumulator.push(carro);
        }
        return accumulator;
      }, [])
      .map(marca => {
        return { Codigo: `8:${marca.Titulo}`, Nome: marca.Titulo };
      });

    const combustivelText = allListaPorVender
      .filter(
        item => ['pecas', 'atrelados', 'motores'].includes(item.Viatura) && item.Combustivel.Nome,
      )
      .map(({ Combustivel }) => {
        return {
          Combustivel: {
            Nome: Combustivel.Nome.trim(),
          },
        };
      })
      .sort(function (a, b) {
        if (a.Combustivel.Nome < b.Combustivel.Nome) {
          return -1;
        }
        if (a.Combustivel.Nome > b.Combustivel.Nome) {
          return 1;
        }
        return 0;
      })
      .reduce((accum, carro) => {
        const accumulator = [...accum];
        if (!accumulator.some(item => item.Combustivel.Nome === carro.Combustivel.Nome)) {
          accumulator.push(carro);
        }
        return accumulator;
      }, [])
      .map(combustivel => {
        return {
          Codigo: `9:${combustivel.Combustivel.Nome}`,
          Nome: 'Motor a ' + combustivel.Combustivel.Nome,
        };
      });

    const categoria = allListaPorVender
      .filter(
        item => ['pecas', 'atrelados', 'motores'].includes(item.Viatura) && item.Categoria.Nome,
      )
      .map(({ Categoria }) => {
        return {
          Categoria,
        };
      })
      .sort(function (a, b) {
        if (a.Categoria.Nome < b.Categoria.Nome) {
          return -1;
        }
        if (a.Categoria.Nome > b.Categoria.Nome) {
          return 1;
        }
        return 0;
      })
      .reduce((accum, carro) => {
        const accumulator = [...accum];
        if (!accumulator.some(item => item.Categoria.Id === carro.Categoria.Id)) {
          accumulator.push(carro);
        }
        return accumulator;
      }, [])
      .map(item => {
        return {
          Codigo: `10:${item.Categoria.Id}`,
          Nome: item.Categoria.Nome,
        };
      });

    const subCategoria = allListaPorVender
      .filter(
        item =>
          ['pecas', 'atrelados', 'motores'].includes(item.Viatura) &&
          item.SubCategoria.Nome &&
          item.SubCategoria.Id !== 163,
      )
      .map(({ SubCategoria }) => {
        return {
          SubCategoria,
        };
      })
      .sort(function (a, b) {
        if (a.SubCategoria.Nome < b.SubCategoria.Nome) {
          return -1;
        }
        if (a.SubCategoria.Nome > b.SubCategoria.Nome) {
          return 1;
        }
        return 0;
      })
      .reduce((accum, carro) => {
        const accumulator = [...accum];
        if (!accumulator.some(item => item.SubCategoria.Id === carro.SubCategoria.Id)) {
          accumulator.push(carro);
        }
        return accumulator;
      }, [])
      .map(item => {
        return {
          Codigo: `11:${item.SubCategoria.Id}`,
          Nome: item.SubCategoria.Nome,
        };
      });

    const marcaText = allListaPorVender
      .filter(item => ['pecas', 'atrelados', 'motores'].includes(item.Viatura) && item.Marca.Nome)
      .map(({ Marca }) => {
        return {
          Marca: {
            Nome: Marca.Nome.trim(),
          },
        };
      })
      .sort(function (a, b) {
        if (a.Marca.Nome < b.Marca.Nome) {
          return -1;
        }
        if (a.Marca.Nome > b.Marca.Nome) {
          return 1;
        }
        return 0;
      })
      .reduce((accum, carro) => {
        const accumulator = [...accum];
        if (!accumulator.some(item => item.Marca.Nome === carro.Marca.Nome)) {
          accumulator.push(carro);
        }
        return accumulator;
      }, [])
      .map(marca => {
        return {
          Codigo: `12:${marca.Marca.Nome}`,
          Nome: marca.Marca.Nome,
        };
      });

    return [
      ...marca,
      ...modelo,
      ...combustivel,
      ...tipo,
      ...lugares,
      ...transmissao,
      ...extras,
      ...titulo,
      ...combustivelText,
      ...categoria,
      ...subCategoria,
      ...marcaText,
    ];
  } catch (error) {
    console.log('error', error);
  }
};

function parsePesquisaQuery(query) {
  const params = {
    marcas: [],
    modelo: [],
    combustivel: [],
    segmento: [],
    transmissao: [],
    extras: [],
    lotacao: [],
    titulo: [],
    combustivelPecas: [],
    categoria: [],
    subcategoria: [],
    marcaPecas: [],
  };
  query.forEach(element => {
    const [key, value] = element.split(':');
    switch (key) {
      case '1':
        params.extras.push(value);
        break;
      // case '2':
      //   params.marcas.push(parseInt(value));
      //   break;
      // case '3':
      //   params.modelo.push(parseInt(value));
      //   break;
      case '4':
        params.combustivel.push(parseInt(value));
        break;
      case '5':
        params.segmento.push(parseInt(value));
        break;
      case '6':
        params.lotacao.push(parseInt(value));
        break;
      case '7':
        params.transmissao.push(parseInt(value));
        break;
      case '8':
        params.titulo.push(value);
        break;
      case '9':
        params.combustivelPecas.push(value);
        break;
      case '10':
        params.categoria.push(parseInt(value));
        break;
      case '11':
        params.subcategoria.push(parseInt(value));
        break;
      case '12':
        params.marcaPecas.push(value);
        break;
      default:
        break;
    }
  });
  return params;
}

function atualizarPesquisaRapida({ marca, modelo }, query, ordenar, array, set, infoJson) {
  try {

    let filterMarca = getArrayByKey(marca, array, 'Marca');
    let filterModelo = getArrayByKey(modelo, array, 'Modelo');
    const params = parsePesquisaQuery(query);

    // Sobrescreva corretamente:
    params.marcas = filterMarca;
    params.modelo = filterModelo;
  
    const marcasSemModelo = getMarcasSemModelo(array, filterMarca, filterModelo);
    const pesquisa = array.filter(carro => filtraCarro(carro, params, marcasSemModelo));
   

    set(
      SelectOrdenar(
        infoJson.Layout.Carros.ordenar.recentes,
        ordenar,
        pesquisa,
        infoJson.Layout.Carros.ordenar.tipo,
        infoJson.Layout.Carros.ordenar.vendidosMisturados,
      ),
    );
  } catch (error) {
    console.log('error', error);
  }
}

function numerosPesquisaRapida({ marca, modelo }, query, array) {
  try {
    let filterMarca = getArrayByKey(marca, array, 'Marca');
    let filterModelo = getArrayByKey(modelo, array, 'Modelo');
    const params = parsePesquisaQuery(query);
    params.modelo = filterModelo;
    params.marcas = filterMarca;

    const marcasSemModelo = getMarcasSemModelo(array, filterMarca, filterModelo);

    const pesquisa = array.filter(carro => filtraCarro(carro, params, marcasSemModelo));
    return pesquisa.length;
  } catch (error) {
    console.log('error', error);
  }
}

const IfIsTransparent = (existe, TransparenteExiste) => {
  return existe && TransparenteExiste;
};

const SelectTiposViatura = key => {
  const viaturaToKeyMap = {
    viaturas: 'carros',
    automoveis: 'carros',
    comerciais: 'carros',
    classicos: 'carros',
    autocaravanas: 'carros',
    'mobile-home': 'carros',
    campanhas: 'carros',
    tractor: 'carros',
    'low-cost': 'carros',
    retomas: 'carros',
    motas: 'motas',
    'motas-novas': 'motas',
    barcos: 'barcos',
    pecas: 'pecas',
    atrelados: 'atrelados',
    motores: 'motores',
    vendidos: '',
    novos: 'carros',
  };
  return viaturaToKeyMap[key];
};

const createLinkPesquisa = (state, infoJson, tipo, key) => {
  switch (key) {
    case 1:
      return `${
        state.Zonas?.Layout.Carros.existe
          ? `${
              infoJson.Layout?.LandingPage?.existe
                ? `/home/${tipo}/#listagem_viaturas`
                : `/${tipo}/#listagem_viaturas`
            }`
          : `/viaturas/${tipo}`
      }`;
    case 2:
      return `${
        state.Zonas?.Layout.Carros.existe
          ? `${infoJson.Layout?.LandingPage?.existe ? `home/${tipo}` : `${tipo}`}`
          : `viaturas/${tipo}`
      }`;
    default:
      return '';
  }
};

const tratarVendido = tipo => {
  if (['motas', 'pecas'].includes(tipo)) {
    return 'Vendida';
  } else {
    return 'Vendido';
  }
};

function mergeObjects(obj1, obj2) {
  const mergedObj = {};

  for (let key in obj1) {
    if (obj2[key]) {
      mergedObj[key] = { ...obj1[key], ...obj2[key] };
    } else {
      mergedObj[key] = { ...obj1[key] };
    }
  }

  for (let key in obj2) {
    if (!obj1[key]) {
      mergedObj[key] = { ...obj2[key] };
    }
  }

  return mergedObj;
}

const parseCommaNumbers = str => str?.toString().split(',').map(Number) || [];
const parseCommaStrings = str => str?.toString().split(',') || [];
const parseIntOrEmpty = str => (str ? parseInt(str) : '');

const getUniqueSorted = (arr, keyFn, sortFn) =>
 arr
    .sort(sortFn)
    .filter((item, idx, self) => self.findIndex(i => keyFn(i) === keyFn(item)) === idx);

function getArrayByKey(value, lista, key) {
  if (!value) return [];
  const arrValue = value.includes('--') ? value.split('--') : [value];

  return  arrValue.flatMap(item =>
    getUniqueSorted(
      lista.filter(carro => carro[key].Id && item ===  LimparToUrl(carro[key].Nome.toLowerCase())),
      i => i[key].Id,
      (a, b) => a[key].Nome.localeCompare(b[key].Nome),
    ).map(item => ({ Id: item[key].Id, Nome: item[key].Nome })),
  );
}

export {
  tratarCombustivel,
  tratarLink,
  tratarAnoMes,
  tratarKm,
  tratarPreco,
  tratarPrecoPromo,
  tratarValorMensalidade,
  tratarCilindrada,
  tratarPotencia,
  tratarConsumos,
  tratarNacional,
  tratar2Chave,
  tratarClassePortagem,
  tratarLivroRevisoes,
  tratarUrl,
  tratarRegistoManutencao,
  tratarDataManutencao,
  trataManutencaoMostraAno,
  LimparToUrl,
  atualizarPesquisa,
  NumeroAtualizarPesquisa,
  SplitValue,
  tratarMotorizacao,
  tratarLinkFinanciamento,
  sortMarcaAZ,
  tratarValorFinanciado,
  createUrl,
  SelectOrdenar,
  createArrayRapida,
  atualizarPesquisaRapida,
  numerosPesquisaRapida,
  formateDate,
  isZero,
  tratarNumeroRegistos,
  IfIsTransparent,
  createLinkPesquisa,
  tratarVendido,
  formatNumber,
  formatNumberCurrency,
  mergeObjects,
  SelectTiposViatura,
  getMarcasComModelo,
  getMarcasSemModelo,
  parseCommaNumbers,
  parseCommaStrings,
  parseIntOrEmpty,
  getArrayByKey,
};
